import { applyInitialThemePreference } from './theme';

applyInitialThemePreference();
